export default __webpack_public_path__ + "static/media/win.3495feb1.mp3";